import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({

  healthControlTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.primary.main
  },

  healthControlContent: {
    paddingTop: 16,
  },

  sectionName: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: -10
  },

}))
